

import { Container } from 'inversify';
import { defineComponent, ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { messages } from './localization/MessagesBusqueda';
import { helpers, required, requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { IapCatalog } from '../../../catalog/domain/iapCatalog';
import { clave, claveNew } from '../../../dataupdate/domain/clave';
import DataSourceComp from '../functions/dataSourceComp';
import HelperCommon from '../../../../../common/infrastructure/funciones/HelperCommon';
import OperationDataTypeConst from '../../../../../common/domain/constantes/OperationDataTypeConst';
import { IServiceDataUpdate } from '../../../dataupdate/application/IServiceDataUpdate';
import { TYPES } from '../../../../../common/domain/types';
import HelperLoading from '../../../../../common/infrastructure/funciones/HelperLoading';
import { LocalService, MessageService } from '../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../common/infrastructure/servicios/MessageService';
import SqlTypesConst from '../../../../../common/domain/constantes/SqlTypesConst';
import { dataUpdate } from '../../../dataupdate/domain/dataUpdate';
import { IapDataSourceField } from '../../../datasource/domain/iapDataSourceField';
import { IapComponentDataSource } from '../../../component/domain/iapComponentDataSource';
import DataSourceConst from '../functions/dataSourceConst';
import { useStore } from 'vuex';
import { IapComponent } from '../../../component/domain/iapComponent';
import CatalogObjectTypeConst from '../../../catalog/domain/const/CatalogObjectTypeConst';
import CatalogExpConst from '../../../catalog/domain/const/CatalogExpConst';
import { ExpresionEngine } from '../../../expression/infrastructure/helper/expressionEngine';
import HelperUtils from '../../../../../common/infrastructure/funciones/HelperUtils';
import LookUpEditor from './LookUpEditor.vue';


export default defineComponent({
    name: 'new_register',
    components:{
        LookUpEditor
    },
    props: {
        container: {
            type: Object as () => Container
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        Component: {
            type: Object as () => IapComponent,
            default: () => ({})
        },


        catalogosData: {
            type: Object as () => IapCatalog[],
            default: () => ([])
        },

        compDataSource: {
            type: Object as () => IapComponentDataSource,
            default: () => ({})
        },
    },
    emits: ['refreshData'],
    setup(props, { emit }) {
        const store = useStore();
        const { t, locale } = useI18n(messages)
        const { isType, isCatalogType, isTableType, dataBaseId, tablasData,hasLookUpByFieldId, getLookUpByFieldId, getDefaultvalue } = DataSourceComp(props.container as any, props, emit, t, props.compDataSource, props.catalogosData,store)
        const submitted = ref(false);
        const dataInput = ref<claveNew[]>([]);        
        const  lookUpData = ref();
        const reglas = {
            items: {
                $each: helpers.forEach({
                    value: {
                        required: helpers.withMessage('El campo es obligatorio', requiredIf((...args) => {
                            var datos = args as any;
                            return datos[args.length - 1].required
                                && !(datos[args.length - 1].value)

                        }
                        )),
                    },
                })
            }
        }

        //requiredIf(prop => prop.type === 'input')


        const v$ = useVuelidate(reglas, { items: dataInput });



        const isColumnType = (columna: string, tipo: string) => {

            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            if (item) {
                return isType(item, tipo);
            }

            return false;
        }


        const isCatalogTypeValue = (columna: string) => {
            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            if (item) {
                const resu = isCatalogType(item)
                return resu
            }
            else {
                return false;
            }
        }


        const isTableTypeValue = (columna: string) => {
            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            if (item) {
                const resu = isTableType(item)
                return resu
            }
            else {
                return false;
            }
        }




        const getCatalogData = (columna: string) => {
            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            if (item) {
                const tipoCatalogoid = item.catalogTypeId
                return props.catalogosData.filter(x => x.typeId == tipoCatalogoid).sort((a, b) => { return a.order - b.order; })
            }
            return []
        }

        const getColumnName = (columna: string) => {
            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            return item?.shortDescription ?? item?.field ?? columna
        }


        const isValidData = (): boolean => {
            submitted.value = true;
            //v$.value.$reset();
            v$.value.$touch();
            if (v$.value.$invalid) {
                HelperCommon.setFocusOnFirstError();
                return false;
            }

            return true;
        }

        const getPrimaryKeys = (): claveNew[] => {
            let _outputData: claveNew[] = [];
            _outputData = tablasData.value.filter(x => x.primaryKey)
                .sort((a, b) => { return (a.position ?? 0) - (b.position ?? 0); })
                .map(x => ({
                    table: x.tableName,
                    field: dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field,
                    value: dataInput.value.find(y => y.field == (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field))?.value,
                    required: !x.nullable
                })) as any
            return _outputData
        }

      

        const saveData = () => {
            if (isValidData()) {  
                              
                const valuesNoAdd = tablasData.value.filter(x => ((!x.identityColumn && !x.primaryKey) || (!x.identityColumn && x.primaryKey))
                    && !props.compDataSource.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.add
                )
                    .sort((a, b) => { return (a.position ?? 0) - (b.position ?? 0); })
                    .map(x => ({
                        dataBase: dataBaseId.value,
                        table: x.tableName,
                        field: dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field,
                        value: getDefaultvalue(x,props.compDataSource.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.defaultValue),
                        required: !x.nullable || props.compDataSource.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.mandatory
                    })) as any

                const dataInputRequest = JSON.parse(JSON.stringify(dataInput.value.concat(valuesNoAdd)));                

                const dataUpdate: dataUpdate = {
                    valores: dataInputRequest.map(x => ({
                        dataBase: x.dataBase,
                        table: x.table,
                        field: x.field,
                        value: isColumnType(x.field, SqlTypesConst.BIT) ? JSON.stringify(x.value) : x.value
                    })) as any,
                    claves: [],
                    tipoOperacion: OperationDataTypeConst.INSERT,
                    id:HelperUtils.newGuid()
                };
                if (props.container) {
                    const _srv = props.container.get<IServiceDataUpdate>(TYPES.DATAUPDATE_REPOSITORY)
                    HelperLoading.showSaving()
                    const requestData = JSON.parse(JSON.stringify(dataUpdate))
                    _srv.update(props.Component.applicationId, props.Component.applicationVersion, props.Component.id, props.compDataSource.id, [requestData],false).then(response => {
                        if (response) {
                            MessageService.showToast(MessageType.Correcto, "", 'Registro creado correctamente.')
                            emit('refreshData')
                        }
                    })
                        .finally(() => {
                            HelperLoading.hideSaving()
                        })
                }
                
            }
        }

      

        const selectedLookUpData = (campo: string,data:any)=>
        {                        
            lookUpData.value = data;
            
            const dsLk = tablasData.value.find(x => campo == (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field))
             // se actualizan el resto de campos
             Object.keys(lookUpData.value).filter(x => x != DataSourceConst.LOOKUPID
                                    && x != DataSourceConst.LOOKUPDESC
                                ).forEach(_field => {
                                    const newValue = lookUpData.value[_field]
                                    const dslnkFields = dsLk?.dataSourceLookUp?.dataSource.iapDataSourceFields.map(x => ({ id: x.id, field: (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) }));
                                    const dataSourceFieldIdSource = dslnkFields?.find((x: any) => x.field == _field)?.id;
                                    const dataSourceFieldIdTarget = dsLk?.dataSourceLookUp?.iapDataSourceLookUpFieldMaps.find(x => x.dataSourceFieldIdSource == dataSourceFieldIdSource)?.dataSourceFieldIdTarget;

                                    const _fieldToUpdate = tablasData.value.find(x => x.id == dataSourceFieldIdTarget)

                                    const _fieldNew = (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate?.tableName + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate?.field)
                                    
                                    const item = dataInput.value.find( x=> x.field == _fieldNew)
                                    if (item){
                                        item.value = newValue
                                    }
                                    
                                })
        
        }
        
        onMounted(() => {
            dataInput.value = tablasData.value.filter(x => ((!x.identityColumn && !x.primaryKey) || (!x.identityColumn && x.primaryKey))
                && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.add
            )
                .sort((a, b) => { return (a.position ?? 0) - (b.position ?? 0); })
                .map(x => ({
                    dataBase: dataBaseId.value,
                    table: x.tableName,
                    field: dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field,
                    value:  getDefaultvalue(x),
                    required: !x.nullable || props.compDataSource.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.mandatory
                })) as any

        })

        return {
            t,
            v$,
            submitted,
            SqlTypesConst,
            dataInput,
            isColumnType,
            isCatalogTypeValue,
            isTableTypeValue,
            getCatalogData,
            getColumnName,
            saveData,
            hasLookUpByFieldId, 
            getLookUpByFieldId,
            selectedLookUpData
        };
    },
});
